import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Coverage } from '@models/swagger';
import { GetCoveragesParams } from './service';

export enum GetCoveragesActions {
  Failure = '[Project GetCoverages] Failure',
  Request = '[Project GetCoverages] Request',
  Success = '[Project GetCoverages] Success',
}

export const GetCoveragesFailure = createAction(GetCoveragesActions.Failure, props<{ error: HttpErrorResponse }>());

export const GetCoveragesRequest = createAction(
  GetCoveragesActions.Request,
  props<{ parameters: GetCoveragesParams }>()
);

export const GetCoveragesSuccess = createAction(GetCoveragesActions.Success, props<{ data: Coverage[] }>());
